import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { precisionRound } from 'utils/math';

const ANIMATION_TICK = 50;
const ANIMATION_STEPS = 20;

const withBangingAnimator = options => BaseComponent => {
  const { name = 'value' } = options || {};

  class BangingAnimator extends PureComponent {
    constructor(props) {
      super(props);

      const startingValue = props[name];
      this.state = {
        displayValue: startingValue,
        animating: false
      };

      this.targetValue = startingValue;
      this.animatingValue = startingValue;
      this.animationIncrement = 0;
      this.animationInterval = null;

      this.animationStep = this.animationStep.bind(this);
    }

    componentWillUnmount() {
      clearInterval(this.animationInterval);
    }

    componentWillReceiveProps(nextProps) {
      const nextValue = nextProps[name];
      const currentValue = this.targetValue;
      if (
        nextValue !== undefined &&
        nextValue !== null &&
        nextValue !== currentValue
      ) {
        const snap =
          currentValue === null ||
          currentValue === undefined ||
          (nextProps.snapDown && nextValue < currentValue);
        if (snap) {
          this.snapValue(nextValue);
        } else {
          this.setTargetValue(nextValue);
        }
      }
    }

    snapValue(score) {
      if (score !== null) {
        this.animatingValue = this.targetValue = score;
        this.setState({
          displayValue: score,
          animating: false
        });
        clearInterval(this.animationInterval);
        this.animationInterval = null;
      }
    }

    setTargetValue(score) {
      if (score !== null && this.targetValue !== score) {
        this.targetValue = score;
        this.animationIncrement =
          (score - this.animatingValue) / ANIMATION_STEPS;

        if (!this.animationInterval) {
          this.animationInterval = setInterval(
            this.animationStep,
            ANIMATION_TICK
          );
        }
      }
    }

    animationStep() {
      this.animatingValue += this.animationIncrement;
      let newDisplay = precisionRound(
        this.animatingValue,
        this.props.precision
      );
      if (
        (this.animationIncrement > 0 && newDisplay >= this.targetValue) ||
        (this.animationIncrement < 0 && newDisplay <= this.targetValue)
      ) {
        newDisplay = this.animatingValue = this.targetValue;
      }

      const newState = { displayValue: newDisplay };

      if (newDisplay === this.targetValue) {
        clearInterval(this.animationInterval);
        this.animationInterval = null;
        newState.animating = false;
      } else if (!this.state.animating) {
        newState.animating = true;
      }

      this.setState(newState);
    }

    render() {
      const { precision, ...otherProps } = this.props;
      const { displayValue, animating } = this.state;
      const childProps = { [name]: displayValue, banging: animating };
      return <BaseComponent {...otherProps} {...childProps} />;
    }
  }

  BangingAnimator.defaultProps = {
    precision: 0,
    snapDown: true
  };

  BangingAnimator.propTypes = {
    precision: PropTypes.number,
    snapDown: PropTypes.bool
  };

  return BangingAnimator;
};

export default withBangingAnimator;
